import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Subject } from 'rxjs';
import { News } from './types/news.model';
import { takeUntil } from 'rxjs/operators';
import { PressService } from '../press.service';
import { LoggingService } from 'app/wipperoz-core/services/logging.service';

@Component({
  selector: 'app-news',
  templateUrl: './news.component.html',
  styleUrls: ['./news.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class NewsComponent implements OnInit, OnDestroy {
  news: News[];
  loading = true;
  private unsubscribeAll: Subject<any>;

  constructor(public pressService: PressService, private loggingService: LoggingService) {
    this.unsubscribeAll = new Subject();
  }

  ngOnInit(): void {
    this.pressService.onNewsChanged.pipe(takeUntil(this.unsubscribeAll)).subscribe(
      (data) => {
        if (data !== null) {
          this.news = data;
          this.loading = false;
        }
      },
      (err) => {
        this.loading = false;
        this.loggingService.logError('Error getting news content', JSON.stringify(err));
      }
    );
    this.pressService.getNews(this.pressService.options);
  }

  ngOnDestroy(): void {
    this.unsubscribeAll.next(null);
    this.unsubscribeAll.complete();
  }

  get numbers(): number[] {
    const limit = Math.ceil(this.pressService.totalCount / this.pressService.options.pageSize);
    return Array.from({ length: limit }, (_, i) => i + 1);
  }

  next() {
    this.pressService.options.page++;
    this.pressService.getNews(this.pressService.options);
  }

  prev() {
    this.pressService.options.page--;
    this.pressService.getNews(this.pressService.options);
  }

  to(page: number) {
    this.pressService.options.page = page;
    this.pressService.getNews(this.pressService.options);
  }
}
